import React from 'react';
import { FormattedMessage } from 'react-intl';
import LazyLoad from 'react-lazyload';

import Description from '@/components/campground-directory/Description';
import AspectRatio from '@/components/common/AspectRatio';
// import css from './CampgroundCard.module.css';
import MarkerCampgrounds from '@/components/icons/MarkerCampgrounds.svg';
import StarAmenities from '@/components/icons/StarAmenities.svg';

const CampgroundCard = ({ campground }) => {
  const { campground_info, url, text, title } = campground;

  const info = campground_info || false;

  const amenities = info && info.activities.map(a => a.name).join(', ');
  const address = info && info.address;
  const imgUrl = info && info.image;

  const addressString = [address.street, address.city, address.state].filter(Boolean).join(', ');

  const reservationUrl = info && info.reservation_url;
  const campgroundUrl = reservationUrl || url;

  const FullCard = () => (
    <div className="flex flex-col items-start my-6 lg:flex-row">
      <div className="flex flex-col lg:w-2/3">
        {imgUrl && (
          <>
            <AspectRatio
              ratio={'5:2'}
              hasImageHover={true}
              className="hidden mt-2 mb-2 bg-gray-200 shadow hover:shadow-lg lg:block">
              <LazyLoad offset={150} once>
                <img src={imgUrl} alt={title} />
              </LazyLoad>
            </AspectRatio>
            <AspectRatio
              ratio={'5:4'}
              hasImageHover={true}
              className="block mt-2 mb-2 bg-gray-200 shadow hover:shadow-lg lg:hidden">
              <LazyLoad offset={150} once>
                <img src={imgUrl} alt={title} />
              </LazyLoad>
            </AspectRatio>
          </>
        )}
        {reservationUrl ? (
          <a href={campgroundUrl} target="_blank" rel="noreferrer" className="mb-2 lg:mt-4">
            <h2 className="text-2xl font-medium text-gray-900">{title}</h2>
          </a>
        ) : (
          <a href={campgroundUrl} className="mb-2 lg:mt-4">
            <h2 className="text-2xl font-medium text-gray-900">{title}</h2>
          </a>
        )}

        <Description
          title={title}
          description={text}
          url={campgroundUrl}
          reservationUrl={reservationUrl}
        />
      </div>

      <div className="relative flex flex-col p-4 text-gray-900 border border-gray-200 rounded shadow-md lg:p-6 lg:mt-2 lg:ml-16 lg:mr-4 lg:w-1/3 hover:shadow-md">
        <div className="flex pt-2 font-bold">
          <div className="absolute">
            <MarkerCampgrounds />
          </div>
          <p className="px-2 pl-8">
            <FormattedMessage defaultMessage="Location info" id="llwDVT" />
          </p>
        </div>
        <div className="pl-8">{addressString}</div>
        <div className="flex pt-4 font-bold">
          <div className="absolute">
            <StarAmenities />
          </div>
          <p className="px-2 pl-8">
            <FormattedMessage defaultMessage="Amenities" id="e38GOF" />
          </p>
        </div>
        <div className="pb-2 pl-8">{amenities}</div>
      </div>
    </div>
  );

  const MiniCard = () => (
    <div className="flex flex-col items-start mt-6 lg:flex-row">
      <div className="flex flex-col pr-6 lg:w-3/4">
        {imgUrl && (
          <>
            <AspectRatio
              ratio={'5:2'}
              hasImageHover={true}
              className="hidden mt-2 mb-2 bg-gray-200 shadow hover:shadow-lg lg:block">
              <LazyLoad offset={150} once>
                <img src={imgUrl} alt={title} />
              </LazyLoad>
            </AspectRatio>
            <AspectRatio
              ratio={'5:4'}
              hasImageHover={true}
              className="block mt-2 mb-2 bg-gray-200 shadow hover:shadow-lg lg:hidden">
              <LazyLoad offset={150} once>
                <img src={imgUrl} alt={title} />
              </LazyLoad>
            </AspectRatio>
          </>
        )}
        <a href={url}>
          <h3 className="mb-2 text-xl font-medium text-gray-900">{title}</h3>
        </a>
        <Description title={title} description={text} url={url} />
      </div>
    </div>
  );

  //         <div className="flex flex-col w-1/4 p-6" />

  if (info) return <FullCard />;

  return <MiniCard />;
};

export default CampgroundCard;
